// Importing assets
import email from '../assets/email.png';
import api from '../assets/api.png';
import css from '../assets/css.png';
import graphql from '../assets/graphql.png';
import html from '../assets/html.png';
import mu5 from '../assets/mu5.png';
import node from '../assets/node.png';
import python from '../assets/python.png';
import redux from '../assets/redux.png';
import sass from '../assets/sass.png';
import vue from '../assets/vue.png';
import java from '../assets/java.png';

import profile from '../assets/Profile.png';
import circle from '../assets/circle.svg';
import logo from '../assets/logo.png';
import mobile from '../assets/mobile.png';
import ai from '../assets/AI.jpg';
import powerBi from "../assets/Power BI.jpeg";

// ✅ Assign to a named variable
const images = {
  email,
  api,
  css,
  graphql,
  html,
  mobile,
  mu5,
  node,
  python,
  redux,
  sass,
  powerBi,
  vue,
  java,
  profile,
  circle,
  logo,
  ai,
};

// ✅ Export the named variable
export default images;
